module.exports = __webpack_public_path__ + "img/aace-logo.201aa357.jpg";